<template>
  <div>
    <template v-if="!loading">
      <div class="content">
        <GlobalBreadcrumb />
        <router-view :key="routePath" />
      </div>
    </template>

    <div class="loader center-middle" v-if="loading">
      <loading-state :size="50" />
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "@vue/composition-api";
import GlobalBreadcrumb from "@/components/smart/GlobalBreadcrumb";
import LoadingState from "@/components/display/LoadingState";
import store from "@/store";

export default {
  name: "DashboardPage",
  components: {
    GlobalBreadcrumb,
    LoadingState,
  },
  setup(props, { root }) {
    const routePath = computed(() => {
      return root.$route.fullPath;
    });

    const breadcrumbs = computed(() => {
      return store.state.nav.breadcrumbs;
    });

    // when first mounted, loading state to grab user info
    const loading = ref(true);

    onMounted(() => {
      store
        .dispatch("auth/userInfo")
        .then(() => {
          store
            .dispatch("auth/clientInfo", { reidentify: true })
            .then(() => {
              loading.value = false;
            })
            .catch(() => {
              root.$router.push({
                name: "logout",
                params: {
                  redirect: routePath,
                },
              });
            });
        })
        .catch(() => {
          root.$router.push({
            name: "logout",
            params: {
              redirect: routePath,
            },
          });
        });
    });

    return {
      loading,
      breadcrumbs,
      routePath,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";

.loader {
  height: 90vh;
}

.content {
  padding: $content-top-padding $grid-gutter-width;
}
</style>
